"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rightArrow = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/right-arrow-3"));

var _leftArrow = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/left-arrow-3"));

var Const = _interopRequireWildcard(require("./PaginationConstants"));

var _utils = require("../utils/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PageButton, _Component);

  var _super = _createSuper(PageButton);

  function PageButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PageButton);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PageButton, [{
    key: "handleClick",
    value: function handleClick(e) {
      e.preventDefault();
      var context = e.currentTarget.textContent;

      if (!context) {
        context = e.currentTarget.childNodes[0].id === 'pre-btn' ? Const.DEFAULT_PRE_PAGE : Const.DEFAULT_NEXT_PAGE;
      }

      this.props.onChangePage(context);
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      if (this.props.index === 0 && this.props.children === Const.DEFAULT_PRE_PAGE) {
        return /*#__PURE__*/_react.default.createElement(_leftArrow.default, {
          noPad: true,
          id: "pre-btn"
        });
      }

      if (this.props.index === this.props.pageCount - 1 && this.props.children === Const.DEFAULT_NEXT_PAGE) {
        return /*#__PURE__*/_react.default.createElement(_rightArrow.default, {
          noPad: true,
          id: "next-btn"
        });
      }

      return this.props.children;
    }
  }, {
    key: "render",
    value: function render() {
      var classes = (0, _classnames.default)({
        'pagination-button': true,
        'active': this.props.active,
        'disabled': this.props.disabled,
        'plain': this.props.plain
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: this.props.disabled,
        onClick: this.handleClick
      }, this.renderButton()));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        index: _propTypes.default.number,
        onChangePage: _propTypes.default.func,
        active: _propTypes.default.bool,
        disabled: _propTypes.default.bool,
        pageCount: _propTypes.default.number
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        onChangePage: _utils.noop
      };
    }
  }]);
  return PageButton;
}(_react.Component);

exports.default = PageButton;